<app-global-style></app-global-style>
<span class="loading-overlay light" #layoutPreloader role="status" aria-live="polite">
  <div class="load-container load8">
    <div class="loader1"></div>
    <label class="preloader-label">{{preloaderLabel}}</label>
  </div>
</span>

<div id="wrapper" [class.toggled]="isSidebarExpanded" [class.menu-hidden]="!isMenuVisible" [class.classic-navigation]="classicNavigation" #menuWrapper>
  <aside id="sidebar-wrapper" *ngIf="isMenuVisible">
    <div class="sidebar-brand">
      <a routerLink="/" class="brand-link" aria-label="myMedax">
        <img [src]="pageLogo || '/assets/themes/mymedax/images/mymedax-logo.svg'" alt="myMedax">
      </a>
      <button type="button" class="sidebar-toggle" (click)="toggleSidebar()"
              [attr.aria-label]="_('Navigation')" [attr.aria-expanded]="isSidebarExpanded">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </button>
    </div>
    <nav class="sidebar-navigation" [attr.aria-label]="_('Navigation')">
      <ul class="sidebar-nav">
        <li class="sidebar-group-label" role="presentation">{{_('Arbeitsbereich')}}</li>
        <ng-container *ngFor="let entry of menu">
          <li class="main" [class.current]="activeSection?.name === entry.name"
              [class.utility-start]="entry.path === '/module/settings/'" *ngIf="isVisible(entry)">
            <div class="sidebar-group-label" *ngIf="entry.path === '/module/settings/'">{{_('Verwaltung')}}</div>
            <a class="menu-link" *ngIf="!classicNavigation" (click)="onNavigate()" [routerLink]="firstVisiblePage(entry)?.path || entry.path"
               [attr.title]="translateMainMenuEntry(entry.name)"
               [attr.aria-current]="activeSection?.name === entry.name ? 'true' : null">
              <i class="fa {{entry.icon}}" aria-hidden="true"></i>
              <span>{{translateMainMenuEntry(entry.name)}}</span>
            </a>
            <!-- classic look: the module opens its pages below, like the side menu before the redesign -->
            <ng-container *ngIf="classicNavigation">
              <a class="menu-link" *ngIf="sectionChildren(entry).length; else classicLink" href="javascript:void(0)" (click)="toggleSection(entry)" [class.open]="isSectionOpen(entry)"
                 [attr.title]="translateMainMenuEntry(entry.name)" [attr.aria-expanded]="isSectionOpen(entry)">
                <i class="fa {{entry.icon}}" aria-hidden="true"></i>
                <span>{{translateMainMenuEntry(entry.name)}}</span>
                <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
              </a>
              <!-- modules without pages (e.g. support) open directly -->
              <ng-template #classicLink>
                <a class="menu-link" (click)="onNavigate()" [routerLink]="entry.path"
                   [attr.title]="translateMainMenuEntry(entry.name)"
                   [attr.aria-current]="activeSection?.name === entry.name ? 'true' : null">
                  <i class="fa {{entry.icon}}" aria-hidden="true"></i>
                  <span>{{translateMainMenuEntry(entry.name)}}</span>
                </a>
              </ng-template>
              <ul class="sub" *ngIf="isSectionOpen(entry)">
                <li *ngFor="let child of sectionChildren(entry)" [class.sub-sub]="child.sub">
                  <a [routerLink]="!child.disabled ? child.path : null" routerLinkActive="active" [class.active]="child === activeMenuEntry"
                     [attr.aria-disabled]="child.disabled || null" (click)="onNavigate()">
                    <i class="fa {{child.icon}}" aria-hidden="true"></i>
                    <span>{{translateMainMenuEntry(entry.name, child.name)}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
        </ng-container>
      </ul>
    </nav>
    <div class="sidebar-footer">
      <ng-template #versionContent>
        <span class="version-icon" aria-hidden="true"><i class="fa fa-code-fork"></i></span>
        <span class="version-details">
          <span class="version-value">{{version}}</span>
        </span>
        <i *ngIf="versionLink" class="fa fa-angle-right version-chevron" aria-hidden="true"></i>
      </ng-template>
      <a *ngIf="versionLink" [routerLink]="versionLink" class="show-version"
         [attr.title]="_('Version') + ': ' + version" [attr.aria-label]="_('Version') + ': ' + version">
        <ng-container *ngTemplateOutlet="versionContent"></ng-container>
      </a>
      <span *ngIf="!versionLink" class="show-version" [attr.title]="_('Version') + ': ' + version">
        <ng-container *ngTemplateOutlet="versionContent"></ng-container>
      </span>
    </div>
  </aside>

  <header class="header" *ngIf="isMenuVisible">
    <div class="content-header">
      <i class="fa {{activeSection?.icon || 'fa-home'}}" aria-hidden="true"></i>
      <h1>{{activeSection ? translateMainMenuEntry(activeSection.name) : (pageTitle || 'myMedax')}}</h1>
      <ng-container *ngIf="activeMenuEntry?.parent">
        <span class="header-separator">/</span>
        <!-- sub page (e.g. Stammdaten / Zusatzfelder): its parent page as link in between -->
        <ng-container *ngIf="parentPage(activeMenuEntry) as parent">
          <a class="header-page header-page-link" [routerLink]="parent.path">{{translateMainMenuEntry(activeSection.name, parent.name)}}</a>
          <span class="header-separator">/</span>
        </ng-container>
        <span class="header-page">{{activeMenuEntry.context ? contextPageLabel(activeMenuEntry) : translateBreadcrumbEntry(activeMenuEntry)}}</span>
      </ng-container>
    </div>
    <div class="header-right">
      <div class="localebox" *ngIf="hasLocaleSupport"><app-locale-select></app-locale-select></div>
      <div *ngIf="user" id="userbox" class="userbox" #userbox (clickOutside)="removeOpenClass($event, userbox)">
        <button type="button" class="user-trigger" (click)="toggleOpenClass($event, userbox)"
                [attr.aria-expanded]="userbox.classList.contains('open')" [attr.aria-label]="user.username">
          <span class="user-avatar" aria-hidden="true">{{user.username?.charAt(0)?.toUpperCase()}}</span>
          <span class="name">{{user.username}}</span>
          <i class="fa fa-angle-down" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu">
          <a *ngFor="let entry of userMenu" [routerLink]="entry.path" (click)="removeOpenClass($event, userbox)">
            <i class="fa {{entry.icon}}" aria-hidden="true"></i>
            <span>{{translateUserMenuEntry(entry.name)}}</span>
          </a>
        </div>
      </div>
    </div>
  </header>

  <main class="workspace">
    <nav class="section-navigation" *ngIf="isMenuVisible && sectionPages.length && !classicNavigation" [attr.aria-label]="translateMainMenuEntry(activeSection.name)">
      <ng-container *ngFor="let entry of sectionPages">
        <a *ngIf="!entry.context" [routerLink]="!entry.disabled ? entry.path : null"
           routerLinkActive="active" [attr.aria-disabled]="entry.disabled || null">
          {{translateMainMenuEntry(activeSection.name, entry.name)}}
        </a>
        <!-- context page (e.g. the loaded patient): only shown while open, long labels are shortened -->
        <a *ngIf="entry.context" class="active section-context-page" aria-current="page" [attr.title]="contextPageLabel(entry)">
          <i class="fa {{entry.icon || 'fa-pencil'}}" aria-hidden="true"></i>
          <span>{{contextPageLabel(entry)}}</span>
        </a>
      </ng-container>
    </nav>
    <div id="page-content-wrapper"><div class="container-fluid"><router-outlet></router-outlet></div></div>
  </main>
</div>
